import React, { useState, useEffect } from 'react';
import { Modal, Box, Typography, TextField, Button, Alert } from '@mui/material';
import { updateCategory, deleteCategory } from '../services/api';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: { xs: '90%', sm: 400 },
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: { xs: 2, sm: 3, md: 4 },
  maxHeight: '90vh',
  overflowY: 'auto'
};

function EditCategoryModal({ open, handleClose, category, onCategoryUpdated }) {
  const [categoryName, setCategoryName] = useState('');
  const [error, setError] = useState('');
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

  useEffect(() => {
    if (category) {
      setCategoryName(category.name);
    }
  }, [category]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    try {
      await updateCategory(category.id, categoryName);
      onCategoryUpdated();
      handleClose();
    } catch (err) {
      console.error("Failed to update category", err);
      setError(err.response?.data?.msg || 'Failed to update category');
    }
  };

  const handleDeleteClick = () => {
    setShowDeleteConfirm(true);
  };

  const handleDeleteConfirm = async () => {
    setError('');
    try {
      await deleteCategory(category.id);
      onCategoryUpdated();
      handleClose();
      setShowDeleteConfirm(false);
    } catch (err) {
      console.error("Failed to delete category", err);
      setError(err.response?.data?.msg || 'Failed to delete category');
      setShowDeleteConfirm(false);
    }
  };

  const handleDeleteCancel = () => {
    setShowDeleteConfirm(false);
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style} component="form" onSubmit={handleSubmit}>
        <Typography id="modal-modal-title" variant="h6" component="h2">
          Edit Category
        </Typography>
        {error && <Alert severity="error" sx={{ mt: 2, mb: 2 }}>{error}</Alert>}
        <TextField
          margin="normal"
          required
          fullWidth
          label="Category Name"
          value={categoryName}
          onChange={(e) => setCategoryName(e.target.value)}
          sx={{ 
            '& .MuiInputBase-input': { 
              fontSize: { xs: '16px', md: '14px' }
            }
          }}
        />
        {!showDeleteConfirm ? (
          <>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
            >
              Update Category
            </Button>
            <Button
              fullWidth
              variant="outlined"
              color="error"
              onClick={handleDeleteClick}
              sx={{ mb: 2 }}
            >
              Delete Category
            </Button>
            <Button
              fullWidth
              variant="outlined"
              onClick={handleClose}
            >
              Cancel
            </Button>
          </>
        ) : (
          <>
            <Typography variant="body2" sx={{ mt: 2, mb: 2 }}>
              Are you sure you want to delete this category? This action cannot be undone.
            </Typography>
            <Button
              fullWidth
              variant="contained"
              color="error"
              onClick={handleDeleteConfirm}
              sx={{ mb: 2 }}
            >
              Yes, Delete Category
            </Button>
            <Button
              fullWidth
              variant="outlined"
              onClick={handleDeleteCancel}
            >
              Cancel
            </Button>
          </>
        )}
      </Box>
    </Modal>
  );
}

export default EditCategoryModal;
